import React, { useState } from "react";
import { Clock, Search } from "lucide-react";
import { PaymentBadge, BookingStatusBadge } from "@/components/dashboard/StatusBadge";
import { useT } from "@/lib/i18n";

const FILTERS = [
  { k: "all", label: "Tout" },
  { k: "CONFIRMED", label: "Confirmées" },
  { k: "IN_PROGRESS", label: "En cours" },
  { k: "COMPLETED", label: "Terminées" },
];

export default function ActivityTimeline({ items, onOpen }) {
  const { t } = useT();
  const [q, setQ] = useState("");
  const [filter, setFilter] = useState("all");

  const filtered = items.filter((b) => {
    const okStatus = filter === "all" || b.status === filter;
    const okSearch = !q || `${b.activity_name} ${b.customer_name}`.toLowerCase().includes(q.toLowerCase());
    return okStatus && okSearch;
  });

  return (
    <div className="rounded-xl border border-slate-200/80 bg-white shadow-[0_1px_3px_0_rgba(15,23,42,0.04)]" data-testid="today-activity-panel">
      <div className="flex flex-col gap-3 border-b border-slate-100 p-5 sm:flex-row sm:items-center sm:justify-between">
        <h3 className="text-lg font-semibold text-slate-900">{t("dash.today_activity")}</h3>
        <div className="relative">
          <Search className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="timeline-search-input" placeholder="Filtrer..."
            className="w-full rounded-lg border border-slate-200 bg-slate-50 py-1.5 pl-9 pr-3 text-sm focus:border-primary focus:bg-white focus:outline-none focus:ring-2 focus:ring-primary/20 sm:w-48" />
        </div>
      </div>
      <div className="flex gap-1.5 border-b border-slate-100 px-5 py-2.5">
        {FILTERS.map((f) => (
          <button key={f.k} onClick={() => setFilter(f.k)} data-testid={`timeline-filter-${f.k}`}
            className={`rounded-lg px-2.5 py-1 text-xs font-medium transition-colors ${filter === f.k ? "bg-slate-900 text-white" : "text-slate-500 hover:bg-slate-100"}`}>
            {f.label}
          </button>
        ))}
      </div>
      <div className="max-h-[420px] divide-y divide-slate-50 overflow-y-auto">
        {filtered.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-14 text-center" data-testid="timeline-empty">
            <Clock className="h-8 w-8 text-slate-300" />
            <p className="mt-2 text-sm text-slate-400">Aucune activité pour cette sélection</p>
          </div>
        ) : filtered.map((b) => (
          <button key={b.id} onClick={() => onOpen?.(b.id)} className="flex w-full items-center gap-4 px-5 py-3.5 text-left transition-colors hover:bg-slate-50/50" data-testid={`timeline-item-${b.id}`}>
            <div className="w-14 shrink-0 text-center">
              <p className="font-mono text-sm font-semibold text-slate-900">{b.start_time}</p>
            </div>
            <div className="min-w-0 flex-1">
              <p className="truncate text-sm font-semibold text-slate-900">
                {b.activity_name} <span className="font-normal text-slate-400">· {b.participants_count} pers.</span>
              </p>
              <p className="truncate text-xs text-slate-500">{b.customer_name} · {b.booking_reference}</p>
            </div>
            <div className="flex shrink-0 flex-col items-end gap-1.5">
              <PaymentBadge status={b.payment_status} />
              <BookingStatusBadge status={b.status} />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
